import ServerErrorCodes from "@services/http/ServerErrorCodes";
import { getLangFromLocal } from "@utils/lang";
import { LocaleLangE } from "./LocaleContext";

const EN_ERRORS = {
  "server_errors.unknown": "Unknown error",
  "server_errors.SystemError": "System error. Try again later.",
  "server_errors.InternalError": "Internal error",
  "server_errors.IncorrectParameters": "Incorrect parameter",
  "server_errors.IncorrectParameterPhone": "Incorrect parameter - wrong phone",
  "server_errors.IncorrectParameterName": "Incorrect parameter - wrong name",
  "server_errors.IncorrectParameterLocationId":
    "Incorrect parameter - wrong location id",
  "server_errors.IncorrectParameterNotes": "Incorrect parameter - wrong notes",
  "server_errors.IncorrectParameterAddress":
    "Incorrect parameter - wrong address",
  "server_errors.IncorrectParameterCoord": "Incorrect parameter - wrong coord",
  "server_errors.IncorrectParameterEmail": "Incorrect parameter - wrong email",
  "server_errors.IncorrectParameterPassword":
    "Incorrect parameter - wrong password",
  "server_errors.IncorrectParameterNEmails":
    "Incorrect parameter - wrong notification emails",
  "server_errors.IncorrectParameterTUser":
    "Incorrect parameter - wrong telegram user",
  "server_errors.IncorrectParameterAbout": "Incorrect parameter - wrong about",
  "server_errors.IncorrectParameterMobile":
    "Incorrect parameter - wrong mobile",
  "server_errors.IncorrectParameterWhatsApp":
    "Incorrect parameter - wrong whatsApp",
  "server_errors.IncorrectParameterMode": "Incorrect parameter - wrong mode",
  "server_errors.IncorrectParameterAlso": "Incorrect parameter - wrong also",
  "server_errors.IncorrectParameterContact":
    "Incorrect parameter - wrong contact",
  "server_errors.IncorrectVerifyCode": "Incorrect verify code",
  "server_errors.VerifyTimeExceeded": "Time to verify the code has expired",
  "server_errors.PasswordsNotEqual": "Passwords not equal",
  "server_errors.UserAlreadyExists": "User already exists",
  "server_errors.UserAlreadyVerified": "User already verified",
  "server_errors.UserNotFound": "User not found",
  "server_errors.UserUnauth": "User unauthorized",
  "server_errors.NeedLogon": "Need logon",
  "server_errors.UserAttemptsLimit": "Login attempts exceeded",
  "server_errors.UserLocked": "User locked",
  "server_errors.PoolSettingNotFound": "Create pool settings",
  "server_errors.PoolSettingAlreadyExists": "Pool setting already exist",
  "server_errors.LocationNotFound": "Location not found",
  "server_errors.LocationAlreadyExists": "Location already exist",
  "server_errors.PermissionDenied": "Permission denied",
  "server_errors.BadPassword": "Password incorrect",
  "server_errors.Need2FA": "Need 2FA",
  "server_errors.Incorrect2FACode": "Incorrect 2FA code",
  "server_errors.PlanNotFound": "Plan not found",
  "server_errors.EmailNotConfirmed": "Email not confirmed",
  "server_errors.UserBanned": "User banned",
  "server_errors.NoWaitingVerifications":
    "No waiting verification for this email",
  "server_errors.DublicatedEmail": "This email already registered",
  "server_errors.MinerNotFound": "Miner not found",
  "server_errors.MinerIsNotOffline": "Miner is not offline. Can not be deleted",
  "server_errors.UserHasMiners": "Can't delete this user while he has a miners",
  "server_errors.TemporarilyDisabled": "Temporarily disabled",
  "server_errors.IncorrectParameterId": "Incorrect parameter - wrong Id",
  "server_errors.IncorrectParameterEdit": "Incorrect parameter - wrong edit",
  "server_errors.IncorrectParameterMinePrc":
    "Incorrect parameter - wrong mining percent",
  "server_errors.IncorrectParameterHash": "Incorrect parameter - wrong hash",
  "server_errors.IncorrectParameterSeparator":
    "Incorrect parameter - wrong separator",
  "server_errors.IncorrectParameterLogin": "Incorrect parameter - wrong login",
  "server_errors.IncorrectParameterNote": "Incorrect parameter - wrong note",
  "server_errors.IncorrectParameterStart": "Incorrect parameter - wrong start",
  "server_errors.IncorrectParameterStop": "Incorrect parameter - wrong stop",
  "server_errors.IncorrectParameterAdminText":
    "Incorrect parameter - wrong admin text",
  "server_errors.IncorrectParameterMinerType":
    "Incorrect parameter - wrong miner type",
  "server_errors.IncorrectParameterDfltSpeed":
    "Incorrect parameter - wrong default speed",
  "server_errors.IncorrectParameterAdmSetting":
    "Incorrect parameter - wrong admin setting",
  "server_errors.IncorrectParameterSpeedDrop":
    "Incorrect parameter - wrong speed drop",
  "server_errors.IncorrectParameterNotification":
    "Incorrect parameter - wrong notifications",
  "server_errors.IncorrectParameterUserId":
    "Incorrect parameter - wrong user Id",
  "server_errors.default": "Request error",
  "server_errors.RackItemIsBusy": "Rack item is busy",
  "server_errors.RackItemIsNotAvailable": "Rack item is not available",
  "server_errors.RackItemNotFound": "Rack item not found",
  "server_errors.RackNotFound": "Rack not found",
  "server_errors.RackItemNotAccessible":
    "Rack item not accessible or miner already exist in rack",
  "server_errors.EquipmentAlreadyExists": "Equipment already exist",
  "server_errors.RackItemNotBeAdd":
    "Rack Item not be added. Rack item was disabled",
  "server_errors.ObjectNotFound": "Object not found",
  "server_errors.BannedFor15Min": "Banned for 15 minutes",
  "server_errors.Incorrect2FAResetCode": "Incorrect 2FA reset code",
  "server_errors.CannotChangeRackName":
    "Unable to change the name of the rack where the miners are installed",
  "server_errors.RackNameExists": "Rack with the same ID already exist",
  "server_errors.SettingHasMiners":
    "Can't delete this setting while it is in use",
  "server_errors.AlreadyExists": "Building name already exists.",
  "server_errors.NotPayment": "Contact with Admin to change the pool",
  "server_errors.PoolSettingNotFoundToSetUser":
    "The user does not have the appropriate settings for this miner",
  "server_errors.ContractDeletionForbidden":
    "The contract already used in miner or user",
  "server_errors.PlanDeletionForbidden":
    "The plan already used in active contract",
  "server_errors.ErrFileIsTooBig": "Max file size 100MB",
  "server_errors.ErrFileIsTooSmall": "Min file size 101 byte",
  "server_errors.OnlyImgOrDocOrArchAccepted":
    "Accepted only: .pdf, .jpg, .png, .jpeg, .doc, .docx",
  "server_errors.CommandMinerNotFound": "Miner not found",
  "server_errors.CannotDeleteRackWhileMinersExist":
    "Cannot delete rack while miners exist",
  "server_errors.ContractIsUsed": "Contract is in use",
  "server_errors.SelfClientPassed": "Can be passed to self client",
};

const RU_ERRORS = {
  "server_errors.unknown": "Неизвестная ошибка",
  "server_errors.SystemError": "Системная ошибка. Попробуйте позже.",
  "server_errors.InternalError": "Внутренняя ошибка",
  "server_errors.IncorrectParameters": "Неверный параметр",
  "server_errors.IncorrectParameterPhone": "Неверный телефон",
  "server_errors.IncorrectParameterName": "Неверное имя",
  "server_errors.IncorrectParameterLocationId": "Неверный ID локации",
  "server_errors.IncorrectParameterNotes": "Неверные записи",
  "server_errors.IncorrectParameterAddress": "Неверный адрес",
  "server_errors.IncorrectParameterCoord": "Неверные координаты",
  "server_errors.IncorrectParameterEmail": "Неверная почта",
  "server_errors.IncorrectParameterPassword": "Неверный пароль",
  "server_errors.IncorrectParameterNEmails": "Неверная почта для уведомлений",
  "server_errors.IncorrectParameterTUser": "Неверный телеграмм пользователь",
  "server_errors.IncorrectParameterAbout": 'Неверный параметр - "о себе"',
  "server_errors.IncorrectParameterMobile": "Неверный мобильный телефон", // старый параметр
  "server_errors.IncorrectParameterWhatsApp": "Неверный whatsApp", // старый параметр
  "server_errors.IncorrectParameterMode": "Неверный параметр - неверный mode", // старый параметр
  "server_errors.IncorrectParameterAlso": "Неверный параметр - неверный also", // старый параметр
  "server_errors.IncorrectParameterContact": "Неверный контакт",
  "server_errors.IncorrectVerifyCode": "Неверный верификационный код",
  "server_errors.VerifyTimeExceeded": "Код подтверждения устарел",
  "server_errors.PasswordsNotEqual": "Пароли не совпадают",
  "server_errors.UserAlreadyExists": "Такой пользователь уже есть",
  "server_errors.UserAlreadyVerified": "Пользователь уже подтвержден",
  "server_errors.UserNotFound": "Пользователь не найден",
  "server_errors.UserUnauth": "Неверный пароль",
  "server_errors.NeedLogon": "Сначала войдите в аккаунт",
  "server_errors.UserAttemptsLimit": "Превышены попытки входа в систему",
  "server_errors.UserLocked": "Пользователь заблокирован",
  "server_errors.PoolSettingNotFound": "Создайте настройку пула",
  "server_errors.PoolSettingAlreadyExists": "Такая настройка пула уже есть",
  "server_errors.LocationNotFound": "Такой локации не существует",
  "server_errors.LocationAlreadyExists": "Такая локация уже существует",
  "server_errors.PermissionDenied": "В действии отказано",
  "server_errors.BadPassword": "Неверный пароль",
  "server_errors.Need2FA": "Необходима двухфакторная аутентификация",
  "server_errors.Incorrect2FACode": "Неверный 2FA код",
  "server_errors.PlanNotFound": "Такого плана не существует",
  "server_errors.EmailNotConfirmed": "Почта не подтверждена",
  "server_errors.UserBanned": "Пользователь заблокирован",
  "server_errors.NoWaitingVerifications":
    "Не нужно ждать подтверждения для этого электронного письма",
  "server_errors.DublicatedEmail": "Эта почта уже подтверждена",
  "server_errors.MinerNotFound": "Майнер не найден",
  "server_errors.MinerIsNotOffline":
    "Майнер не выключен, поэтому не может быть удален",
  "server_errors.UserHasMiners":
    "Невозможно удалить пользователя, пока у него есть майнеры",
  "server_errors.TemporarilyDisabled": "Временно отключен",
  "server_errors.IncorrectParameterId": "Неверный ID",
  "server_errors.IncorrectParameterEdit": "Некорретный параметр для изменения",
  "server_errors.IncorrectParameterMinePrc": "Некорретный процент майнинга",
  "server_errors.IncorrectParameterHash": "Некорретный алгоритм",
  "server_errors.IncorrectParameterSeparator": "Некорретный делитель",
  "server_errors.IncorrectParameterLogin": "Неверный логин",
  "server_errors.IncorrectParameterNote": "Неверная запись",
  "server_errors.IncorrectParameterStart": "Ошибка при старте майнера",
  "server_errors.IncorrectParameterStop": "Ошибка при остановке майнера",
  "server_errors.IncorrectParameterAdminText": "Ошибка отправки сообщения",
  "server_errors.IncorrectParameterMinerType": "Некорректный тип майнера",
  "server_errors.IncorrectParameterDfltSpeed":
    "Некорректная номинальная скорость майнера",
  "server_errors.IncorrectParameterAdmSetting":
    "Некорректная настройка для майнинга на админа",
  "server_errors.IncorrectParameterSpeedDrop":
    "Некорректный процент снижения скорости",
  "server_errors.IncorrectParameterNotification":
    "Ошибка при установке уведомлений",
  "server_errors.IncorrectParameterUserId": "Некорректный ID пользователя",
  "server_errors.default": "Ошибка обработки запроса",
  "server_errors.RackItemIsBusy": "Секция занята",
  "server_errors.RackItemIsNotAvailable": "Секция шкафа недоступна",
  "server_errors.RackItemNotFound": "Секция не найдена",
  "server_errors.RackNotFound": "Шкаф не найден",
  "server_errors.RackItemNotAccessible":
    "Секция в шкафу недоступна или майнер уже находится в шкафу",
  "server_errors.EquipmentAlreadyExists": "Такое борудование уже существует",
  "server_errors.RackItemNotBeAdd": "Ячейка заблокирована или ее не существует",
  "server_errors.ObjectNotFound": "Строение не найдено",
  "server_errors.BannedFor15Min": "Вы заблокированы на 15 минут",
  "server_errors.Incorrect2FAResetCode": "Неверный код восстановления",
  "server_errors.CannotChangeRackName":
    "Невозможно сменить ID шкафа, если в нем есть майнеры",
  "server_errors.RackNameExists": "Шкаф с таким ID уже есть",
  "server_errors.SettingHasMiners":
    "Невозможно удалить настроку пока с ней работают майнеры",
  "server_errors.AlreadyExists": "Такое имя обьекта уже существует",
  "server_errors.NotPayment": "Свяжитесь с администратором для смены пула",
  "server_errors.PoolSettingNotFoundToSetUser":
    "У пользователя нет подходящей настройки для этого майнера",
  "server_errors.ContractDeletionForbidden":
    "Невозможно удалить контракт, который используется в майнере или клиенте",
  "server_errors.PlanDeletionForbidden":
    "Невозможно удалить план, который используется в активном контракте",
  "server_errors.ErrFileIsTooBig":
    "Файл слишком велик. Максимальный размер 100Мб",
  "server_errors.ErrFileIsTooSmall":
    "Фай слишком мал. Минимальный размер 101 байт",
  "server_errors.OnlyImgOrDocOrArchAccepted":
    "Разрешены только: .pdf, .jpg, .png, .jpeg, .doc, .docx",
  "server_errors.CommandMinerNotFound": "Майнер не найден",
  "server_errors.CannotDeleteRackWhileMinersExist":
    "Невозможно удалить шкаф, если в нем есть майнеры",
  "server_errors.ContractIsUsed": "Контракт используется",
  "server_errors.SelfClientPassed": "Can be passed to self client",
};

export const serverErrors = (errorCode: ServerErrorCodes): string => {
  const isRus = (getLangFromLocal() as LocaleLangE) === LocaleLangE.RU;
  let errKey = "";
  const errors = isRus ? RU_ERRORS : EN_ERRORS;
  if (errorCode === -1) {
    return errors["server_errors.unknown"];
  }
  for (const key in ServerErrorCodes) {
    if (ServerErrorCodes[key as keyof typeof ServerErrorCodes] === errorCode)
      errKey = `server_errors.${key}`;
  }
  if (!errKey.length) return errors["server_errors.default"];

  return errors[errKey as keyof typeof errors];
};
